<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {Device} from "@/utils";
import {mapGetters} from "vuex";
import {polyfill} from "mobile-drag-drop";
import {scrollBehaviourDragImageTranslateOverride} from "mobile-drag-drop/scroll-behaviour";

export default {
  name: 'App',
  async created() {
    try{
      await Device.detectDevice();

      if(Device.isMobile()){
          polyfill({
            dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
          });
      }
    }catch(e){
      console.error(e);
    }
  },
  computed: {
    ...mapGetters('room', ['isFullScreen'])
  },
  mounted() {
    Device.orientationchange();
  },
  watch:{
    async isFullScreen(val){
      try {
        if (val) {
          if(this.$el.webkitRequestFullscreen)
            await this.$el.webkitRequestFullscreen();
          else if(this.$el.requestFullscreen)
            await this.$el.requestFullscreen()
        }else{
          const docu = this.getDocument();
          if(docu.webkitIsFullScreen)
            await docu.webkitExitFullscreen()
          else if(docu.fullscreen)
            await docu.exitFullscreen()
        }
      }catch (e) {
        console.warn('# full screen error', e);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
}
</style>
